var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "modules-wrap" },
    [
      _c(
        "div",
        { staticClass: "table" },
        [
          _vm.is_print_member_no == 1
            ? _c(
                "el-collapse",
                { attrs: { accordion: "" } },
                _vm._l(_vm.tableData, function (item, index) {
                  return _c(
                    "el-collapse-item",
                    { key: item[_vm.id], staticClass: "table-row" },
                    [
                      _c("template", { slot: "title" }, [
                        _c("div", { staticClass: "table-row-header" }, [
                          _c("div", { staticClass: "header-content" }, [
                            _c("div", { staticClass: "content-left" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    `${index + 1}# ${item.product_title}`
                                  ) +
                                  " "
                              ),
                            ]),
                            _c("div", [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("总件数："),
                              ]),
                              _vm._v(_vm._s(item.product_number) + "  /  "),
                              _c("span", { staticClass: "label" }, [
                                _vm._v("等级："),
                              ]),
                              _vm._v(_vm._s(item.product_grade) + "  /  "),
                              _c("span", { staticClass: "label" }, [
                                _vm._v("规格："),
                              ]),
                              _vm._v(_vm._s(item.product_spec) + " "),
                            ]),
                          ]),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "print-btn",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.onHandlePrint(item)
                              },
                            },
                          },
                          [_vm._v("打印标签")]
                        ),
                      ]),
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: item.order_detail_list,
                            border: true,
                            "header-cell-style": {
                              color: "#333333",
                              background: "#EFF6FF",
                            },
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "logistics_name",
                              label: "城市仓名称",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "delivery_name",
                              label: "自提点名称",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "vehicle_no",
                              label: "车位号",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "sort_code",
                              label: "坑位号",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "member_name",
                              label: "客户名称",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "member_mobile",
                              label: "客户电话",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "qty",
                              label: "订货数量",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "no_print_num",
                              label: "未打印数量",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "address",
                              label: "功能",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleEdit(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("打印标签")]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                }),
                1
              )
            : _c(
                "div",
                _vm._l(_vm.tableData, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: item[_vm.id],
                      staticClass: "table-row",
                      staticStyle: { display: "flex" },
                    },
                    [
                      _c("div", { staticClass: "table-row-header" }, [
                        _c("div", { staticClass: "header-content" }, [
                          _c("div", { staticClass: "content-left" }, [
                            _vm._v(
                              " " +
                                _vm._s(`${index + 1}# ${item.product_title}`) +
                                " "
                            ),
                          ]),
                          _c("div", [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("总件数："),
                            ]),
                            _vm._v(_vm._s(item.product_number) + "  /  "),
                            _c("span", { staticClass: "label" }, [
                              _vm._v("等级："),
                            ]),
                            _vm._v(_vm._s(item.product_grade) + "  /  "),
                            _c("span", { staticClass: "label" }, [
                              _vm._v("规格："),
                            ]),
                            _vm._v(_vm._s(item.product_spec) + " "),
                          ]),
                        ]),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "print-btn",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.onHandlePrint(item)
                            },
                          },
                        },
                        [_vm._v("打印标签")]
                      ),
                    ]
                  )
                }),
                0
              ),
        ],
        1
      ),
      _vm.dataobj
        ? _c(
            "el-dialog",
            {
              staticClass: "dialog",
              attrs: {
                title: "提示",
                visible: _vm.dialogVisible,
                "close-on-click-modal": false,
                "close-on-press-escape": false,
                width: "40%",
                center: "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "contents" },
                [
                  _c("div", { staticClass: "goods-wrap" }, [
                    _vm._v(" 商品名称：" + _vm._s(_vm.dataobj.title) + " "),
                  ]),
                  _c("div", { staticClass: "goods-wrap" }, [
                    _vm._v(
                      _vm._s(_vm.dataobj.logistics_name) +
                        " " +
                        _vm._s(_vm.dataobj.delivery_name)
                    ),
                  ]),
                  _c("div", { staticClass: "goods-wrap" }, [
                    _vm._v(
                      "坑位号：" +
                        _vm._s(_vm.dataobj.sort_code) +
                        " 订货数量 ：" +
                        _vm._s(_vm.dataobj.qty)
                    ),
                  ]),
                  _c(
                    "el-form",
                    {
                      ref: "refForm",
                      attrs: { model: _vm.formData, rules: _vm.formRules },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "打印数量：", prop: "print_num" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "输入打印数量",
                              maxlength: "5",
                              clearable: "",
                            },
                            model: {
                              value: _vm.formData.print_num,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "print_num", $$v)
                              },
                              expression: "formData.print_num",
                            },
                          }),
                          _vm._v(" 个 "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c("el-button", { on: { click: _vm.onHandleClose } }, [
                    _vm._v("取消"),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.onHandleSubmit(_vm.dataobj)
                        },
                      },
                    },
                    [_vm._v("确认打印")]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }